import { atom } from 'recoil';

export const userPageCurrentPageCommonTransferState = atom({
  key: 'userPageCurrentPageCommonTransferState',
  default: {
    countPerPage: 20,
    currentPage: 1,
    totalCount: 1,
  },
});
